<script>
    import Modal from './Modal.svelte';
	import { modal } from './stores.js';
    import PopupPublishNote from './PopupPublishNote.svelte';
    export let postUid;
    export let slug;
    export let isPublished;
</script>

<Modal show={$modal}>
    <PopupPublishNote postUid={postUid} slug={slug} isPublished={isPublished} />
</Modal>